var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsListPage',{attrs:{"title":"企业新闻","category-name":"企业新闻","category-path":"enterprise","root-class":"enterprise-news","page-size":6}})
}
var staticRenderFns = []

export { render, staticRenderFns }